const STORAGE_KEY = 'bbtv_client_install_id';

function generateInstallId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `bbtv-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getClientInstallId() {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const next = generateInstallId();
    localStorage.setItem(STORAGE_KEY, next);
    return next;
  } catch (error) {
    return generateInstallId();
  }
}
